var keyCodes_default = {
  ENTER: 13,
  SPACE: 32,
  TAB: 9,
  ESC: 27,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40
};
export {
  keyCodes_default as default
};
//# sourceMappingURL=keyCodes.js.map
